import React from 'react'

/**
 * Top-level Error Boundary — catches any unhandled render error in the tree
 * and shows a friendly fallback instead of a blank screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Uncaught render error:', error, info.componentStack)
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', minHeight: '100vh',
        background: '#0f172a', color: '#f1f5f9',
        fontFamily: 'Inter, system-ui, sans-serif', gap: 16, padding: 32
      }}>
        <div style={{ fontSize: 48 }}>⚠️</div>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, letterSpacing: '-0.5px' }}>
          Something went wrong
        </h1>
        <p style={{
          color: '#94a3b8', margin: 0, textAlign: 'center',
          maxWidth: 420, fontSize: 14, lineHeight: 1.6
        }}>
          {this.state.error?.message || 'An unexpected error occurred in the admin panel.'}
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: 12, padding: '10px 28px',
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
            border: 'none', borderRadius: 10,
            color: '#fff', cursor: 'pointer',
            fontWeight: 600, fontSize: 14,
            boxShadow: '0 4px 15px rgba(99,102,241,0.35)'
          }}
        >
          Reload App
        </button>
        <p style={{ color: '#475569', fontSize: 11, marginTop: 4 }}>
          If this keeps happening, check the browser console for details.
        </p>
      </div>
    )
  }
}

export default ErrorBoundary
